import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { Role, Api } from "types/models";
import { catalogService } from "api";
export interface State {
  detailPhieuXuatVien: any;
  detailPhieuNhapVien: any;
}

const initialState: State = {
  detailPhieuXuatVien: null,
  detailPhieuNhapVien: null,
};

export const nurseOutSlice = createSlice({
  name: "nurseOut",
  initialState: initialState,
  reducers: {
    setDetailPhieuXuatVien: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return { ...state, detailPhieuXuatVien: action.payload };
    },
    setDetailPhieuNhapVien: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return { ...state, detailPhieuNhapVien: action.payload };
    },
  },
});

export const { setDetailPhieuXuatVien, setDetailPhieuNhapVien } =
  nurseOutSlice.actions;

export default nurseOutSlice.reducer;
